interface TranslationSection {
  [key: string]: string | TranslationSection;
}

interface Translations {
  [lang: string]: TranslationSection;
}

const translations: Translations = {
  pl: {
    nav: {
      home: "Strona główna",
      offer: "Oferta",
      about: "O nas",
      contact: "Kontakt",
    },
    home: {
      heroTitle: "Autorskie maszyny przemysłowe",
      heroSubtitle: "Precyzja. Stal. Technologia.",
      heroCta: "Zobacz ofertę",
      machinesTitle: "Nasze maszyny",
    },
    offer: {
      title: "Oferta",
      subtitle: "Sprawdzone konstrukcje do cięcia materiałów",
      standardEquipment: "Wyposażenie standardowe",
      optionalEquipment: "Opcje dodatkowe",
      error: "Nie udało się załadować oferty",
      noProducts: "Brak produktów w tej kategorii",
    },
    categories: {
      title: "Kategorie",
      name: "Nazwa",
      nameEn: "Nazwa EN",
      sortOrder: "Kolejność",
      add: "Dodaj kategorię",
      edit: "Edytuj kategorię",
      delete: "Usuń",
      deleteConfirm: "Usunąć kategorię?",
      save: "Zapisz",
      cancel: "Anuluj",
      noCategories: "Brak kategorii",
      usedByProducts: "Kategoria jest używana przez produkty",
    },
    about: {
      title: "O firmie",
      subtitle: "Autorskie maszyny przemysłowe od podstaw",
      heading: "O nas",
      body: "Jesteśmy firmą produkującą urządzenia do krojenia różnego rodzaju materiałów dla branży tekstylnej, tapicerskiej oraz technicznej. Oferujemy zarówno standardowe modele, jak i konstrukcje projektowane na zamówienie, dostosowane do wymagań konkretnej produkcji.",
    },
    contact: {
      title: "Kontakt",
      subtitle: "Skontaktuj się z nami",
      detailsTitle: "Dane kontaktowe",
      formTitle: "Wyślij zapytanie",
      name: "Imię i nazwisko *",
      email: "Adres e-mail *",
      phone: "Telefon",
      message: "Wiadomość *",
      send: "Wyślij",
      nameRequired: "Proszę wypełnić wymagane pola.",
      mailInfo: "Powinien otworzyć się Twój klient pocztowy z gotową wiadomością.",
      emailLabel: "E-mail",
      phoneLabel: "Telefon",
      addressLabel: "Adres",
      hoursLabel: "Godziny otwarcia",
      hoursWeekday: "Pon–Pt: 8:00 – 16:00",
      hoursWeekend: "Sobota–Niedziela: nieczynne",
      companyLabel: "Dane firmy",
      warranty: "Oferujemy 24 miesiące gwarancji na wszystkie maszyny. Zapewniamy wsparcie techniczne i serwis pogwarancyjny.",
    },
    privacy: {
      title: "Polityka prywatności",
      intro: "Niniejsza polityka prywatności określa zasady przetwarzania danych osobowych użytkowników strony internetowej Mazur Masz Paweł Mazur.",
      s1title: "1. Administrator danych",
      s1body: "Administratorem danych osobowych jest MAZURMASZ Paweł Mazur, 95-030 Rzgów, woj. łódzkie, NIP: 731 198 96 08.",
      s2title: "2. Zakres zbieranych danych",
      s2body1: "Strona nie zbiera żadnych danych osobowych automatycznie. Formularz kontaktowy przetwarza wyłącznie dane dobrowolnie podane przez użytkownika (imię, e-mail, numer telefonu, treść wiadomości) — wiadomość jest wysyłana bezpośrednio za pośrednictwem klienta pocztowego użytkownika (mailto) i nie jest przechowywana na serwerze.",
      s2body2: "Strona zawiera osadzoną mapę Google Maps, która może przetwarzać adres IP użytkownika zgodnie z polityką prywatności Google.",
      s3title: "3. Cel przetwarzania danych",
      s3body: "Dane przetwarzane są wyłącznie w celu udzielenia odpowiedzi na zapytanie wysłane za pośrednictwem formularza kontaktowego.",
      s4title: "4. Pliki cookies",
      s4body: "Strona korzysta z plików cookies wyłącznie w celu zapewnienia prawidłowego działania i przechowywania sesji. Nie są wykorzystywane do śledzenia użytkowników ani wyświetlania reklam.",
      s5title: "5. Udostępnianie danych",
      s5body: "Dane nie są przekazywane podmiotom trzecim, chyba że wymagają tego przepisy prawa.",
      s6title: "6. Prawa użytkownika",
      s6body: "Użytkownik ma prawo dostępu do swoich danych, ich sprostowania, usunięcia oraz ograniczenia przetwarzania. W celu realizacji tych praw prosimy o kontakt na adres e-mail: mazurmasz@gmail.com.",
      updated: "Ostatnia aktualizacja: 13 lipca 2026",
    },
    footer: {
      copyright: "Autorskie maszyny do cięcia materiałów",
      privacyPolicy: "Polityka prywatności",
    },
    notFound: {
      title: "404",
      message: "Strona nie została znaleziona",
      back: "Wróć do strony głównej",
    },
  },
  en: {
    nav: {
      home: "Home",
      offer: "Offer",
      about: "About",
      contact: "Contact",
    },
    home: {
      heroTitle: "Custom Industrial Machines",
      heroSubtitle: "Precision. Steel. Technology.",
      heroCta: "View offer",
      machinesTitle: "Our machines",
    },
    offer: {
      title: "Offer",
      subtitle: "Proven solutions for material cutting",
      standardEquipment: "Standard equipment",
      optionalEquipment: "Optional equipment",
      error: "Failed to load offer",
      noProducts: "No products in this category",
    },
    categories: {
      title: "Categories",
      name: "Name",
      nameEn: "Name EN",
      sortOrder: "Sort order",
      add: "Add category",
      edit: "Edit category",
      delete: "Delete",
      deleteConfirm: "Delete category?",
      save: "Save",
      cancel: "Cancel",
      noCategories: "No categories",
      usedByProducts: "Category is used by products",
    },
    about: {
      title: "About us",
      subtitle: "Custom industrial machines from scratch",
      heading: "About us",
      body: "We manufacture cutting machines for textiles, upholstery, and technical materials. We offer both standard models and custom-built solutions tailored to specific production requirements.",
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch with us",
      detailsTitle: "Contact details",
      formTitle: "Send an inquiry",
      name: "Full name *",
      email: "Email address *",
      phone: "Phone",
      message: "Message *",
      send: "Send",
      nameRequired: "Please fill in all required fields.",
      mailInfo: "Your email client should open with a ready message.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      addressLabel: "Address",
      hoursLabel: "Opening hours",
      hoursWeekday: "Mon–Fri: 8:00 AM – 4:00 PM",
      hoursWeekend: "Saturday–Sunday: closed",
      companyLabel: "Company info",
      warranty: "We offer 24-month warranty on all machines. Technical support and post-warranty service available.",
    },
    privacy: {
      title: "Privacy Policy",
      intro: "This privacy policy defines the rules for processing personal data of users of the Mazur Masz Paweł Mazur website.",
      s1title: "1. Data controller",
      s1body: "The data controller is MAZURMASZ Paweł Mazur, 95-030 Rzgów, Poland, NIP: 731 198 96 08.",
      s2title: "2. Scope of collected data",
      s2body1: "The website does not automatically collect any personal data. The contact form processes only data voluntarily provided by the user (name, email, phone number, message content) — the message is sent directly via the user's email client (mailto) and is not stored on the server.",
      s2body2: "The website contains an embedded Google Maps map, which may process the user's IP address in accordance with Google's privacy policy.",
      s3title: "3. Purpose of data processing",
      s3body: "Data is processed solely for the purpose of responding to inquiries sent via the contact form.",
      s4title: "4. Cookies",
      s4body: "The website uses cookies only to ensure proper functionality and session storage. They are not used for tracking users or displaying advertisements.",
      s5title: "5. Data sharing",
      s5body: "Data is not shared with third parties unless required by law.",
      s6title: "6. User rights",
      s6body: "Users have the right to access, rectify, delete, and restrict the processing of their data. To exercise these rights, please contact us at: mazurmasz@gmail.com.",
      updated: "Last updated: July 13, 2026",
    },
    footer: {
      copyright: "Custom material cutting machines",
      privacyPolicy: "Privacy Policy",
    },
    notFound: {
      title: "404",
      message: "Page not found",
      back: "Back to homepage",
    },
  },
};

export default translations;
